// ─── Informações pessoais ───────────────────────────────────────────────────
export const profile = {
  name: "Ana Elisa Alves",
  title: "Fashion Designer",
  location: "Brasília, DF",
  email: "anaelisasantos368@gmail.com",
  phone: "(61) 99613-1810",
  tagline: "FASHION IS A SELF-TRANSLATION",
  aboutSummary: "Estudante de Design de Moda no IESB com foco em criações e identidade visual.",
  aboutFull: (
      <>
        <strong>Ana Elisa, </strong>
        <br /><br />
        Me chamo Ana Elisa Alves e minha trajetória na moda começou desde pequena, quando eu amava fazer o styling das pessoas da minha família e das minhas amigas. Sempre gostei de montar looks, testar combinações e, de alguma forma, usar a roupa para mostrar um pouco da personalidade de cada pessoa.

        <br /><br />
        Em 2025, comecei a faculdade de Design de Moda no Centro Universitário IESB, onde venho descobrindo cada vez mais sobre a área e sobre o que gosto de fazer dentro dela. Tenho interesse principalmente em criação, produção de moda e marketing de moda.

        <br /><br />
        Muitas das minhas inspirações vêm de referências culturais, artísticas e simbólicas que me atravessam de alguma forma. Gosto de observar o que está ao meu redor e transformar essas referências em ideias e projetos que tenham significado na minha pessoa.
        <br /><br />
          Para mim, a moda vai muito além das roupas. É mais do que vestir: é uma linguagem, uma forma de comunicar, se expressar e existir.

      </>
  ),


  tags: [
    "Marketing e Produto",
    "Produção de Moda",
    "Criação de Coleções",
    "Pesquisa de Tendências",
    
  ],
};

// ─── Coleções ────────────────────────────────────────────────────────────────
 
export const collections = [
  {
    id: "colecao-01",
    title: "A PERSUASÃO DE DRAMA EM FLOR",
    subtitle: "DRAMA EM FLOR",
    description: `Inspirada no barroco, esta coleção explora a dramaticidade, o excesso e o contraste como linguagem estética, traduzindo a natureza em sua forma mais intensa e emocional. Paisagens exuberantes e movimentos orgânicos servem como ponto de partida para silhuetas expressivas, volumes marcantes e jogos de luz e sombra.
 
A coleção propõe um diálogo entre arte, natureza e emoção, onde o vestuário se torna uma extensão da paisagem, denso, poético e profundamente sensorial.
 
Composta por peças que evocam a opulência barroca, com detalhes como corsets estruturados, saias volumosas e aplicações de flores. As linhas curvas, as texturas ricas e a paleta vibrante remetem a um jardim em expansão, onde cada peça é uma expressão da natureza em sua forma mais intensa e emocional.`,
    extraInfo: `A persuasão desta coleção nasce do contraste entre delicadeza e excesso. As flores deixam de ser apenas ornamento e assumem papel narrativo: conduzem o olhar, ampliam a sensação de movimento e reforçam o impacto dramático de cada silhueta.
 
No conjunto, a proposta cria uma experiência emocional que aproxima arte e moda, convidando o público a ler cada look como uma cena viva de um jardim teatral.`,
    moodboard: "/images/moodboard-co1pt2.png",   // placeholder
    croquis:   "/images/croquis.webp",     // placeholder
    looks: [
      {
        id: "look-01",
        title: "LOOK CONFECCIONADO PARA PASSARELA",
        description: `A peça traz uma releitura contemporânea do barroco, inspirada em suas paisagens exuberantes e na teatralidade das formas orgânicas. O corset estruturado, adornado por rosas volumosas, dialoga com a opulência barroca, enquanto a saia marcada por arabescos dourados e flores aplicadas remete ao crescimento sinuoso da natureza.
 
As linhas curvas, as texturas ricas e a paleta vibrante evocam um jardim em expansão, criando uma composição que celebra a beleza dramática e ornamental desse período artístico. Arames envolvidos com fita floral complementam o acessório dos braços.`,
        materials: (
            <>
         <div>
           <strong style={{ display: "block" }}>Conceito:</strong>
        <span>Barroco • Natureza • Luz e Claro</span>
         </div>
         <br/>
            <div>
              <strong style={{ display: "block" }}>Materiais:</strong>
              <span>Cetim Bucol • Fita de Gorgurão • Botões Pérola</span>
            </div>
         </>
        ),
        image: "/images/passarela.webp",        // placeholder
      },
      {
        id: "colecao-02",
        title: "SEGUNDO LOOK CRIADO",
        description: `Esse segundo look faz parte da minha segunda coleção, apresentada em outro desfile. Nesse trabalho, tivemos que desenvolver, em dupla, uma peça inspirada no Surrealismo, com elementos relacionados aos sonhos e a temas psicodélicos. Tivemos também influências como Alice no País das Maravilhas para a realização desse look.
 
O look apresenta um visual conceitual e impactante, misturando a leveza da organza com a estrutura do crepe. O destaque criativo fica para a aplicação de cartas de baralho na saia, que trazem movimento e narrativa à peça. O acabamento une o brilho do strass ao peso das correntes de metal, com elásticos garantindo o ajuste ao corpo.`,
        materials: (
            <>
              <div>
                <strong style={{ display: "block" }}>Conceito:</strong>
                <span>Surrealismo • Psicodelia • Alice no País das Maravilhas</span>
              </div>
              <br/>
              <div>
                <strong style={{ display: "block" }}>Materiais:</strong>
                <span>Organza • Correntes de Metal • Strass • Tecido Crepe • Cartas de Baralho</span>
              </div>
            </>
        ),
        secondMoodboard: "/images/moodboard-co2.webp", // moodboard da segunda coleção
        image: "/images/segundacol.webp",        // placeholder
      },
      {
        id: "estagio-leticiagonzaga",
        title: "A correria da moda",
        description: `Estágio realizado durante a graduação, com trabalho organizacional nas redes sociais, produção de conteúdo e apoio em ações da marca.`,
        materials: (
            <>
              <div>
                <strong style={{ display: "block" }}>Conceito:</strong>
                <span>Marca de Moda • Social Media • 2026</span>
              </div>
              <br/>
              <div>
                <strong style={{ display: "block" }}>Materiais:</strong>
                <span>Substitua pelos materiais, técnicas ou acabamentos usados.</span>
              </div>
            </>
        ),
      },
    ],
  },
 
  // ── Coleção 03 ──────────────────────────────────────────────────────────
  {
    id: "estagio-leticiagonzaga",
    title: "A correria da moda",
    subtitle: "Estágio na marca Letícia Gonzaga",
    description: `Substitua por um texto descrevendo o conceito, a inspiração e a proposta estética
desta coleção.`,
    extraInfo: `Substitua por informações adicionais sobre a coleção (processo criativo, contexto
de apresentação, etc).`,
    moodboard: "/images/moodboard-co3.webp",   // placeholder — troque pela imagem real
    croquis:   "/images/croquis-co3.webp",     // placeholder — troque pela imagem real
    looks: [
      {
        id: "look-co3-01",
        title: "SUBSTITUA PELO TÍTULO DO LOOK",
        description: `Substitua pela descrição do look: conceito, silhueta, técnicas construtivas e
detalhes de acabamento.`,
        materials: (
            <>
              <div>
                <strong style={{ display: "block" }}>Conceito:</strong>
                <span>Substitua pelas palavras-chave do conceito</span>
              </div>
              <br/>
              <div>
                <strong style={{ display: "block" }}>Materiais:</strong>
                <span>Substitua pelos materiais utilizados</span>
              </div>
            </>
        ),
        image: "/images/look-co3-01.webp", // placeholder
      },
    ],
  },
 
  // ── Coleção 04 ──────────────────────────────────────────────────────────
  {
    id: "editorial-street-hype",
    title: "SUBSTITUA PELO TÍTULO DA COLEÇÃO 04",
    subtitle: "SUBSTITUA PELO SUBTÍTULO",
    description: `Substitua por um texto descrevendo o conceito, a inspiração e a proposta estética
desta coleção.`,
    extraInfo: `Substitua por informações adicionais sobre a coleção.`,
    moodboard: "/images/moodboard-co4.webp",   // placeholder
    croquis:   "/images/croquis-co4.webp",     // placeholder
    looks: [
      {
        id: "look-co4-01",
        title: "SUBSTITUA PELO TÍTULO DO LOOK",
        description: `Substitua pela descrição do look.`,
        materials: (
            <>
              <div>
                <strong style={{ display: "block" }}>Conceito:</strong>
                <span>Substitua pelas palavras-chave do conceito</span>
              </div>
              <br/>
              <div>
                <strong style={{ display: "block" }}>Materiais:</strong>
                <span>Substitua pelos materiais utilizados</span>
              </div>
            </>
        ),
        image: "/images/look-co4-01.webp", // placeholder
      },
    ],
  },
 
  // ── Coleção 05 ──────────────────────────────────────────────────────────
  {
    id: "colecao-05",
    title: "SUBSTITUA PELO TÍTULO DA COLEÇÃO 05",
    subtitle: "SUBSTITUA PELO SUBTÍTULO",
    description: `Substitua por um texto descrevendo o conceito, a inspiração e a proposta estética
desta coleção.`,
    extraInfo: `Substitua por informações adicionais sobre a coleção.`,
    moodboard: "/images/moodboard-co5.webp",   // placeholder
    croquis:   "/images/croquis-co5.webp",     // placeholder
    looks: [
      {
        id: "look-co5-01",
        title: "SUBSTITUA PELO TÍTULO DO LOOK",
        description: `Substitua pela descrição do look.`,
        materials: (
            <>
              <div>
                <strong style={{ display: "block" }}>Conceito:</strong>
                <span>Substitua pelas palavras-chave do conceito</span>
              </div>
              <br/>
              <div>
                <strong style={{ display: "block" }}>Materiais:</strong>
                <span>Substitua pelos materiais utilizados</span>
              </div>
            </>
        ),
        image: "/images/look-co5-01.webp", // placeholder
      },
    ],
  },
 
  // Adicione mais coleções seguindo o mesmo padrão acima
 
];

// ─── Cards do carrossel de coleções ──────────────────────────────────────────
// Edite texto e imagens dos cards aqui. Adicione/remova objetos para mudar o carrossel.
// Observações:
// - Coloque as imagens na pasta `public/images/` (ex: public/images/minha-imagem.webp).
// - Atualize `image` (capa do card) e adicione caminhos em `gallery` para múltiplas imagens.
// - `gallery` aceita um array de strings; o componente pode usar `image` como capa e `gallery` para a galeria.
export const collectionCarouselCards = [
  {
    id: "drama-em-flor",
    eyebrow: "Coleção 01",
    title: "Drama em Flor",
    description:
      "Coleção inspirada no barroco, com contraste, excesso, flores aplicadas e silhuetas dramáticas.",
    details: "Barroco • Natureza • Drama",
    image: "/images/passarela.webp",
    gallery: ["/images/passarela.webp", "/images/moodboard-co1pt2.png", "/images/croquis.webp"],
    longDescription:
      "A coleção Drama em Flor explora a teatralidade barroca e a força visual da natureza. O look principal combina corset estruturado, rosas volumosas, arabescos dourados e uma composição pensada para passarela.",
    materials: "Cetim bucol, fita de gorgurão, botões pérola, flores aplicadas e arames envolvidos com fita floral.",
  },
  {
    id: "capitulo-surreal",
    eyebrow: "Coleção 02",
    title: "Capítulo Surreal",
    description:
      "Coleção conceitual com referências ao surrealismo, sonhos, psicodelia e Alice no País das Maravilhas.",
    details: "Surrealismo • Psicodelia • Fantasia",
    image: "/images/segundacol.webp",
    gallery: ["/images/segundacol.webp", "/images/moodboard-co2.webp"],
    longDescription:
      "O Capítulo Surreal apresenta uma proposta visual experimental, misturando fantasia e impacto. A peça trabalha organza, crepe, cartas de baralho, correntes e strass para criar uma narrativa ligada aos sonhos.",
    materials: "Organza, tecido crepe, correntes de metal, strass, elásticos e cartas de baralho.",
  },
  {
    id: "estagio-leticiagonzaga",
    eyebrow: "Estágio e Eventos",
    title: "A correria da moda",
    description:
      "Local que organiza os eventos realizados durante a graduação e também o estágio realizado pela marca Letícia Gonzaga, em Brasília.",
    details: "Eventos por Brasília • Marca de Moda • Desfiles",
    // Imagem de capa do card (troque pelo arquivo em public/images/)
    image: "/images/fotomanequins.jpg",
    // Gallery: adicione múltiplas imagens aqui, por exemplo:
    // gallery: ["/images/fotomanequins.jpg", "/images/fotomanequins-2.webp"]
    // Atualizado: mostrar `trabalhoparamarcaderoupa` e `trabalhoparamarcaderoupa(1)` lado a lado
    gallery: [
      "/images/trabalhoparamarcaderoupa.jpg",
      "/images/trabalhoparamarcaderoupa(1).jpg",
      "/images/backstage (1).jpg",
      "/images/backstage (2).jpg",
      "/images/backstage.jpg",
      "/images/backstage2.jpg",
      "/images/backstage3.jpg",
      "/images/backstage4.jpg",
    ],
    longDescription:
  `Durante minha graduação em Design de Moda, realizei um estágio na marca Letícia Gonzaga, em Brasília, atuando na organização e produção de eventos, nas redes sociais e na atualização de conteúdos do site. A experiência me permitiu desenvolver habilidades de organização, comunicação, criatividade e trabalho em equipe, além de conhecer de perto os bastidores e processos de uma marca de moda.
  Também participei de eventos de moda em Brasília, como o IESB Fashion Show - Metamorfose, realizado como um desfile de encerramento do semestre, realizado dia 27 de junho de 2026.`,
    materials: "Produção de conteúdo, organização de eventos, social media",
  },
  {
    id: "editorial-street-hype",
    eyebrow: "Editorial 01",
    title: "Street HYPE",
    description:
      "O editorial HYPE foi desenvolvido a partir da proposta de unir o universo artesanal do crochê à estética do streetwear, criando uma composição que equilibra delicadeza, textura e atitude urbana.",
    details: "Brasileirismo • Crochê • Streetwear",
    // Capa do card - troque pelo seu arquivo em public/images/
    image: "/images/streethypebolsa.jpg",
    // Exemplo de múltiplas imagens na galeria:
    // gallery: ["/images/look-02.svg", "/images/colecao04-2.webp", "/images/colecao04-3.webp"]
    gallery: ["/images/editorialstreerHYPEim2.jpg", "/images/editorialstreetHYPEim1.jpg", "/images/editorialstreetHYPEim3.jpg", "/images/fotohypeadd.jpg", "/images/fotohypeadd2.jpg", "/images/fotohypeadd1.jpg"],
    longDescription:
      "O editorial HYPE foi desenvolvido a partir da proposta de unir o universo artesanal do crochê à estética do streetwear, criando uma composição que equilibra delicadeza, textura e atitude urbana. A produção buscou explorar novas possibilidades para o uso do crochê na moda, mostrando como peças artesanais podem ser incorporadas a uma proposta contemporânea e despojada.A escolha do styling e da composição visual reforça essa mistura de referências, criando looks com personalidade e uma identidade jovem. O editorial representa a experimentação entre diferentes linguagens da moda, valorizando o contraste entre o feito à mão e a estética urbana característica do streetwear.",
    materials: "Artesanato • Crochê • Streetwear • Estilo Urbano",
  },
  {
    id: "calorardente",
    eyebrow: "Editorial 02",
    title: "Calor Ardente",
    description:
      "Calor Ardente é um editorial inspirado na estética sunburn, explorando a intensidade do verão por meio de uma fotografia marcada por tons quentes, iluminação alaranjada e uma atmosfera sensual e vibrante.",
    details: "Sunburn • Verão • Modelo",
      // Capa do card
    image: "/images/calorardenteim1.jpg",
    // Adicione outras imagens à galeria conforme necessário
    gallery: ["/images/calorardenteim4.jpg", "/images/calorardenteim2.jpg" , "/images/calorardenteim3.jpg"  ],
    longDescription:
      "Calor Ardente é um editorial inspirado na estética sunburn, explorando a intensidade do verão por meio de uma fotografia marcada por tons quentes, iluminação alaranjada e uma atmosfera sensual e vibrante. A estética busca transmitir a sensação de calor na pele, utilizando a luz e a proximidade entre os modelos para criar imagens intimistas e envolventes.O editorial foi desenvolvido como um trabalho da faculdade e contou com a minha participação como modelo, Ana Elisa Alves, junto com Fabiano Manzoli. A produção foi realizada em parceria com uma dupla de amigas, contribuindo para a construção do conceito, da estética e da narrativa visual do projeto.",
    materials: "Modelo • Fotografia • Styling",
  },
  {
    id: "4lmost-trash",
    eyebrow: "Coleção 03",
    title: "4lmost Trash",
    description:
      "A 4lmost Trash é uma coleção que explora a estética do upcycling, transformando materiais descartados em peças de moda inovadoras e sustentáveis.",
    details: "Upcycling • Sustentabilidade • Moda Consciente",
    // Capa do card
    image: "/images/4lmost Trash look fem.jpg",
    // Adicione outras imagens à galeria conforme necessário
    gallery: ["/images/4lmost Trash look fem (criações).jpg", "/images/4lmost Trash look fem ( criações).jpg", "/images/4lmost Trash look mas (criações).jpg", "/images/4lmost Trash look mas (criações)(1).jpg", "/images/4lmostrashedit1 (1).jpeg", "/images/4lmostrashedit1 (2).jpeg", "/images/4lmosttrashedit2 (1).jpeg", "/images/4lmosttrashedit2 (2).jpeg", "/images/4lmosttrashedit2 (3).jpeg", "/images/4lmosttrashedit2 (4).jpeg"],
    longDescription:
      "A 4lmost Trash é uma marca criada para um projeto da faculdade de Design de Moda, com foco em sustentabilidade, criatividade e reaproveitamento de materiais. A proposta surgiu a partir da utilização de retalhos que seriam descartados, transformando-os em peças de roupa com uma estética contemporânea e urbana. Todos os looks da coleção foram confeccionados exclusivamente com retalhos, valorizando suas diferentes cores, texturas e formas. Dessa maneira, a marca busca mostrar que materiais considerados “lixo” podem ganhar novos significados e se transformar em peças de moda únicas, reforçando a importância do upcycling e de uma produção mais consciente dentro da indústria da moda.",
    materials: "Retalhos, Metais, Correntes, Tecidos diversos, Botões",
  },
];

// ─── Experiências ────────────────────────────────────────────────────────────
export const experiences = [
  {
    id: "DF FASHION WEEK",
    title: "DF FASHION WEEK",
    period: "2025 – 2025",
    description: "Trabalhei no backstage do primeiro Distrito Federal Fashion Week, " +
        "contribuindo para a " +
        "produção e organização de um dos maiores eventos de moda de Brasília.",
  },
  {
    id: "METRÓPOLES CATWALK",
    title: "METRÓPOLES CATWALK",
    period: "2025 – 2026",
    description: "Participação ativa no backstage do Metrópoles Catwalk, " +
        "auxiliando na coordenação de " +
        "desfiles e styling durante o evento.",
  },
  {
    id: "EVENTOS UNB",
    title: "EVENTOS UNB",
    period: "2025 – 2025",
    description: "Colaboração em eventos de moda realizados na Universidade de Brasília, " +
        "ampliando conhecimento sobre a indústria da moda.",
  },
  {
    id: "I ENCONTRO DE MODA",
    title: "I ENCONTRO DE MODA",
    period: "2025 – 2025",
    description: "Participação como aluna no I Encontro " +
        " Moda de Brasília (UNB), com carga horária de 20 horas.",
  },
   {
    id: "METAMORFOSE",
    title: "METAMORFOSE",
    period: "2026 – 2026",
    description: "Participação como estilista e criadora " +
        " Teatro Nacional de Brasília. IESB",
  },
];

// ─── Certificados ────────────────────────────────────────────────────────────
export const certificates = [
  {
    id: "cert-01",
    title: "Nome do Certificado",
    image: "/images/certificado-dffw-_2_.png",    // placeholder
  },
  {
    id: "cert-02",
    title: "Nome do Certificado",
    image: "/images/certificado-unb.png",    // placeholder
  },
];
